import React from 'react';
import PropTypes from 'prop-types';

import DialogOverrideContext from './dialogOverrideContext';

const DialogOverrideProvider = ({ overrides, children }) => (
  <DialogOverrideContext.Provider value={overrides ?? {}}>
    {children}
  </DialogOverrideContext.Provider>
);

DialogOverrideProvider.propTypes = {
  overrides: PropTypes.objectOf(PropTypes.object),
  children: PropTypes.node,
};

export default DialogOverrideProvider;
